import * as Actions from "./actions";
import initialState from "../store/initialState";

export const UsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.SIGN_IN:
      return {
        ...state,
        ...action.payload,
      };
    case Actions.SIGN_OUT:
      return {
        ...action.payload
      };
    case Actions.NEW_BOOK:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state;
  }
};
